import { render, staticRenderFns } from "./index.vue?vue&type=template&id=448b26b0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=448b26b0&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b26b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448b26b0')) {
      api.createRecord('448b26b0', component.options)
    } else {
      api.reload('448b26b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=448b26b0&scoped=true", function () {
      api.rerender('448b26b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/Textarea/index.vue"
export default component.exports